"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const removeContributionsData = graphql_tag_1.default `
  mutation($id: String!, $environmentId: String!, $type: String!) {
    removeContributionsData(id: $id, environmentId: $environmentId, type: $type) {
      id
      environmentId
      type
      agentId
      contribution
      data
    }
  }
`;
exports.default = removeContributionsData;
//# sourceMappingURL=removeContributionsData.js.map